<template>
    <div>
        <base-crud
            :ref="table"
            :crudName="crudName"
            :newText="newText"
            :table="table"
            :columns="columns"
            :options="options"
            :endPoint='endPoint'
            :enableAdd="true"
            :enableEdit="true"
            :enableDelete="true"
            :enableView="false"
            :dataForm="dataForm"
            @fieldUpdated="fieldUpdated"
        >
        </base-crud>
    </div>
</template>

<script>
    import BaseCrud from '../Base/BaseCrud'
    export default {
        data() {
            return {
                crudName: 'Departamento',
                newText: 'Cadastrar Departamento',
                table: 'sectorsTable',
                columns: ['id', 'company_id', 'branch_id', 'name', 'responsible_id', 'actions'],
                tableData: ['id', 'company_id', 'branch_id', 'name', 'responsible_id'],
                options: {
                    filterByColumn: true,
                    debounce: 1000,
                    sortable: ['id', 'company_id', 'branch_id', 'name', 'responsible_id'],
                    filterable: ['id', 'company_id', 'branch_id', 'name'],
                    pagination: {chunk: 10, dropdown: false, nav: 'scroll' },
                    perPage: 10,
                    perPageValues: [10,25,50,100],
                    headings: {
                        'id': '#',
                        'company_id': 'Empresa',
                        'branch_id': 'Unidade',
                        'name': 'Nome',
                        'responsible_id': 'Responsável',
                        'actions' : 'Ações'
                    },
                    templates: {
                        company_id: function(h, row, index){
                            return row.company ? row.company.fantasy_name : ''
                        },
                        branch_id: function(h, row, index){
                            return row.branch ? row.branch.name : ''
                        },
                        responsible_id: function(h, row, index){
                            return row.responsible ? row.responsible.name : ''
                        }
                    },
                    requestFunction: function (data) {
                        let requestData = {};

                        let query = this.$parent.$parent.query(data.query);
                        requestData.params = data;
                        requestData.params.query = '';
                        requestData.params.with = [
                          'company',
                          'branch',
                          'responsible'
                        ];

                        return this.$http
                            .get(this.url + '?' + query, requestData)
                            .catch(function (e) {
                                    this.dispatch("error", e);
                                }.bind(this)
                            );
                    }
                },
                endPoint: 'sectors/',
                dataForm: {
                  title: {
                    add: 'Novo Departamento',
                    edit: 'Editar Departamento',
                    view: 'Visualizar Departamento',
                    icon: 'fa fa-pen'
                  },
                  button: {
                    back: '/sectors'
                  },
                  url: {
                    model: 'sectors'
                  },
                  messages: {
                    success: {
                      add: 'Departamento cadastrado com sucesso!',
                      edit: 'Departamento alterado com sucesso!'
                    }
                  },
                  fields: [
                    {
                      name: 'company_id',
                      model: 'company_id',
                      label: 'Empresa',
                      type: 'select',
                      isRequired: {
                        add: true,
                        edit: true,
                      },
                      placeholder: '',
                      class: '',
                      length: "12|12|12",
                      offset: null,
                      list: [],
                      list_label: 'fantasy_name',
                      isRelated: [
                        'branch_id'
                      ]
                    },
                    {
                      name: 'branch_id',
                      model: 'branch_id',
                      label: 'Unidade',
                      type: 'select',
                      isRequired: {
                        add: true,
                        edit: true,
                      },
                      placeholder: '',
                      class: '',
                      length: "12|12|12",
                      offset: null,
                      list: [],
                      list_label: 'name',
                      isRelated: [
                        'responsible_id'
                      ]
                    },
                    {
                      name: 'name',
                      model: 'name',
                      label: 'Nome',
                      type: 'text',
                      isRequired: {
                        add: true,
                        edit: true,
                      },
                      placeholder: '',
                      class: '',
                      length: "12|6|6",
                      offset: null
                    },
                    {
                      name: 'responsible_id',
                      model: 'responsible_id',
                      label: 'Responsável',
                      type: 'select',
                      isRequired: {
                        add: false,
                        edit: false,
                      },
                      placeholder: '',
                      class: '',
                      length: "12|6|6",
                      offset: null,
                      list: [],
                      list_label: 'name'
                    },
                  ]
                }
            }
        },
        methods: {
          fieldUpdated: function(field){
            const self = this;
            if(field.model == 'company_id'){
              let filters = '&company_id=' + field.value
              self.getBranches(filters)
            } else if(field.model == 'branch_id'){
              let filters = '&branch_id=' + field.value
              self.getUsers(filters)
            }
          },
          query: function (query) {
            let columns = {
              id: 'id',
              name : 'name',
              company_id: 'company[fantasy_name]',
              branch_id: 'branch[name]',
              cnpj: 'cnpj',
              adress: 'adress',
            };
            let filters = '';
            $.each(query, function (index, value) {
                filters += columns[index] + '=' + value + '&';
            });

            return filters;
          },
          getCompanies: function(filters){
            const self = this;
            const api = self.$store.state.api + 'companies?paginated=false' + (filters ? filters : '');
            self.$http.get(api)
              .then((response) => {
                let found = self.dataForm.fields.find(x => x.name == 'company_id')
                if(found){
                  found.list = response.data.data
                }
              }).catch((error) => {
                  self.$message('Erro', error.response.data, 'error');
              });
          },
          getBranches: function(filters){
            const self = this;
            const api = self.$store.state.api + 'branches?paginated=false' + (filters ? filters : '');
            self.$http.get(api)
              .then((response) => {
                let found = self.dataForm.fields.find(x => x.name == 'branch_id')
                if(found){
                  found.list = response.data.data
                }
              }).catch((error) => {
                  self.$message('Erro', error.response.data, 'error');
              });
          },
          getUsers: function(filters){
            const self = this;
            const api = self.$store.state.api + 'users?paginated=false' + (filters ? filters : '');
            self.$http.get(api)
              .then((response) => {
                let found = self.dataForm.fields.find(x => x.name == 'responsible_id')
                if(found){
                  found.list = response.data.data
                }
              }).catch((error) => {
                  self.$message('Erro', error.response.data, 'error');
              });
          }
        },
        mounted(){
          const self = this;
          self.getCompanies();
          self.getBranches();
          self.getUsers();
        },
        components: {
            BaseCrud
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Sector/Crud.vue